import { useContext, useState } from 'react';
import { urlList } from 'src/context/url';
import { UserContext } from 'src/context/userContext';
import { AccountContext } from 'src/context/accountContext';

export interface Account {
  name: string;
  id: string;
  type: string;
  permissionLevel?: 'ADMINISTER' | 'READ_AND_LIMITED_ACTION' | 'READ_ONLY';
}

export const useGetAccounts = (): [
  boolean,
  Error | null,
  Account[] | null,
  () => void,
] => {
  const { recentAccounts, setRecentAccounts } = useContext(AccountContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const [data, setData] = useState<Account[] | null>(null);
  const user = useContext(UserContext);

  const getAccounts = () => {
    setLoading(true);
    fetch(urlList.accounts, {
      method: 'GET',
      headers: {
        Authorization: user.token,
        'Content-Type': 'application/json',
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          const apiResponse = await res.json();
          if (apiResponse.message) {
            throw new Error(`GetAccounts API: Error: ${apiResponse.message}`);
          }
        }
        return res;
      })
      .then((res) => res.json())
      .then((res) => {
        // update the recent accounts with new data from the fetch
        const updatedRecentAccounts: Account[] = [];
        recentAccounts?.map((recentAccount) => {
          const accountToUpdate = res.find(
            (account: Account) => account.id === recentAccount.id,
          );
          // if the account in recent is no longer in the account list, it gets removed
          accountToUpdate && updatedRecentAccounts.push(accountToUpdate);
        });

        setRecentAccounts(updatedRecentAccounts);
        setData(res);
      })
      .catch((e) => {
        setError(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return [loading, error, data, getAccounts];
};
